// frontend/src/components/event/EventTypeBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  Presentation,
  Wrench,
  Users,
  GraduationCap,
  Building2,
  Mic,
} from "lucide-react";

const EventTypeBadge = ({ type, size = "md" }) => {
  const { t } = useLanguage();

  const typeConfig = {
    webinar: {
      label: { de: "Webinar", en: "Webinar" },
      icon: Presentation,
      color: "bg-blue-100 text-blue-700",
    },
    workshop: {
      label: { de: "Workshop", en: "Workshop" },
      icon: Wrench,
      color: "bg-orange-100 text-orange-700",
    },
    meetup: {
      label: { de: "Meetup", en: "Meetup" },
      icon: Users,
      color: "bg-green-100 text-green-700",
    },
    course: {
      label: { de: "Kurs", en: "Course" },
      icon: GraduationCap,
      color: "bg-purple-100 text-purple-700",
    },
    conference: {
      label: { de: "Konferenz", en: "Conference" },
      icon: Building2,
      color: "bg-red-100 text-red-700",
    },
    talk: {
      label: { de: "Vortrag", en: "Talk" },
      icon: Mic,
      color: "bg-teal-100 text-teal-700",
    },
  };

  const config = typeConfig[type] || typeConfig.webinar;
  const Icon = config.icon;

  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.color} ${sizeClasses[size]}`}
    >
      <Icon className={iconSizes[size]} />
      {t(config.label)}
    </span>
  );
};

export default EventTypeBadge;
